import { cn } from "@flare/ui";

import type { ChoiceBoxProps } from "@/components/Funnel/ChoiceBox";
import { ChoiceBox, ChoiceBoxItem } from "@/components/Funnel/ChoiceBox";

export type ChoiceItem = { label: string; value: string } | string;

export type ChoiceBoxContentProps = {
  choices: ChoiceItem[];
  className?: string;
} & ChoiceBoxProps;

export function ChoiceBoxContent({
  choices,
  className,
  ...restProps
}: ChoiceBoxContentProps) {
  return (
    <ChoiceBox
      className={cn(
        "mx-auto mt-8 flex w-full max-w-[520px] flex-col",
        className,
      )}
      {...restProps}
    >
      {choices.map((choice) => {
        const { label, value } =
          typeof choice === "string"
            ? { label: choice, value: choice }
            : { label: choice.label, value: choice.value };

        return (
          <ChoiceBoxItem key={value} value={value}>
            {label}
          </ChoiceBoxItem>
        );
      })}
    </ChoiceBox>
  );
}
